import React from "react";
import { Greeting, MemberNumber } from "./ProfileIntroHelpers";
import { useAppSelector } from "../../../hooks";
import { crmBasicProfileSelector } from "../../../redux/slices/Member/member";

const ProfileIntro: React.FC = () => {
  const crmBasicProfile: any = useAppSelector(crmBasicProfileSelector);

  return (
    <>
      {crmBasicProfile && (
        <div className="text-center text-lg-start">
          <Greeting firstName={crmBasicProfile.firstName} />
          <MemberNumber memberNumber={crmBasicProfile.memberId} />
        </div>
      )}
    </>
  );
};
export default ProfileIntro;
